// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);


          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }

        });
        if (!parsedState.errors) {
          this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        }
        this.updateLiveRegions(line, parsedState.item_count, parsedState.errors);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateCartCounters();
        updateFreeShipping();
      })
      .finally(() => {
        this.classList.remove('is-loading')
        loadDraweRecomendations()
        reinitProductsFeed();
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () => this.open());
    this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error("Cart link not found");
    }
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add("is-visible");
    document.querySelector('body').style.overflow = 'hidden';
    this.addEventListener("transitionend", () => { this.focusOnCartDrawer(); }, { once: true });

    setTimeout(() => {
      document.addEventListener("click", this.handleOutsideClick);
    }, 100);

    const productReccomendations = document.querySelector(".product-recommendations");
    if (productReccomendations) {
      if (productReccomendations.classList.contains("hidden")) {
        document.querySelector(".cart-drawer-items").classList.add("cart-drawer-items__full");
      } else {
        document.querySelector(".cart-drawer-items").classList.remove("cart-drawer-items__full");
      }
    }
    loadDraweRecomendations(true)
    reinitProductsFeed();
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector('body').style.overflow = 'auto';
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );

      updateCartCounters();
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);


/* FUNCIÓN PARA EL CARRUSEL EN CARRITO: K-UX */
function reinitProductsFeed() {
  document.querySelectorAll('card-product-slider').forEach(el => {
    try {
      const hasUrl = el.hasAttribute('data-url');
      const canFetch = typeof el.fetchItems === 'function';
      const canInit = typeof el.initSlider === 'function';
      if (hasUrl && canFetch) {
        el.fetchItems();
        return;
      }
      if (hasUrl && !canFetch) {
        const url = el.getAttribute('data-url');
        if (!url) return;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fetchedEl = doc.querySelector('card-product-slider') || doc.querySelector('.card-product-slider') || doc.querySelector('.swiper.card-product-slider');

            if (fetchedEl) {
              el.innerHTML = fetchedEl.innerHTML;
            } else {
              const wrapper = doc.querySelector('.swiper-wrapper');
              const targetWrapper = el.querySelector('.swiper-wrapper');
              if (!wrapper || !targetWrapper) return;
              targetWrapper.innerHTML = wrapper.innerHTML;
            }
            try {
              const siteUsesIcon = (window.theme && window.theme.settings && (window.theme.settings.product_card_add_to_cart_btn_content || '').toString().indexOf('icon') !== -1) || !!document.querySelector('.product-card__add-to-cart--button.button--icon, .quick-cart-drawer__trigger.button--icon');
              if (siteUsesIcon) {
                const plusSvg = '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 4V12M12 12V20M12 12H4M12 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
                el.querySelectorAll('.quick-cart-drawer__trigger').forEach(btn => {
                  const hasIcon = btn.querySelector('svg');
                  const loadingEl = btn.querySelector('.quick-cart-drawer__trigger--loading');
                  const labelText = (btn.textContent || '').trim();
                  if (!hasIcon && labelText) {
                    btn.classList.add('button--icon');
                    btn.classList.remove('button--text', 'button--filled', 'button--uppercase');
                    if (loadingEl) loadingEl.remove();
                    btn.innerHTML = `${plusSvg}<span class="visually-hidden">${labelText}</span>`;
                    if (loadingEl) btn.appendChild(loadingEl);
                  }
                });
                setTimeout(() => {
                  if (document.querySelector('quick-cart-drawer')) {
                    try { document.querySelector('quick-cart-drawer').init(); } catch(e) { /* ignore */ }
                  }
                }, 200);
              }
            } catch (e) {
            }
            let swiperOptions = {};
            try {
              swiperOptions = JSON.parse((fetchedEl && fetchedEl.getAttribute('data-swiper-options')) || el.getAttribute('data-swiper-options') || '{}');
            } catch (e) {
              swiperOptions = {};
            }
            const sliderOptions = {
              a11y: false,
              threshold: 3,
              spaceBetween: swiperOptions.spaceBetweenMobile || 2,
              slidesPerView: swiperOptions.slidesPerViewMobile || 'auto',
              breakpoints: {
                750: {
                  slidesPerView: 3,
                  spaceBetween: swiperOptions.spaceBetweenDesktop || 2
                },
                1100: {
                  slidesPerView: 4,
                  spaceBetween: swiperOptions.spaceBetweenDesktop || 2
                }
              }
            };

            if (swiperOptions.navigation) {
              sliderOptions.navigation = {
                prevEl: `.swiper-button--prev-${el.dataset.sectionId}`,
                nextEl: `.swiper-button--next-${el.dataset.sectionId}`
              };
            }

            if (swiperOptions.autoplay) sliderOptions.autoplay = swiperOptions.autoplay;
            if (swiperOptions.loop) sliderOptions.loop = swiperOptions.loop;

            try {
              const slider = new Swiper(el, sliderOptions);

              slider.wrapperEl.setAttribute('aria-live', 'polite');
              slider.wrapperEl.id = `swiper-wrapper-${el.dataset.sectionId}`;
              slider.slides.forEach((slide, i) => {
                slide.setAttribute('role', 'group');
                slide.setAttribute('aria-label', `${i + 1} / ${slider.slides.length}`);
                slide.dataset.index = i;
              });
              slider.wrapperEl.addEventListener('mouseenter', () => slider.autoplay && slider.autoplay.stop());
              slider.wrapperEl.addEventListener('mouseleave', () => {
                if (!el.classList.contains('product--open-on-quick-cart') && sliderOptions.autoplay) slider.autoplay.start();
                if (swiperOptions.autoplay === false) slider.autoplay.stop();
              });
              el.querySelectorAll('product-card').forEach(card => {
                try { if (typeof card.init === 'function') card.init(); } catch (e) { /* ignore */ }
              });
              if (typeof el.syncHeights === 'function') el.syncHeights();
            } catch (err) {
              console.error('Failed to init Swiper for products-feed fallback', err);
            }
          })
          .catch(err => console.error(err));
        return;
      }
      if (canInit) {
        el.initSlider();
        el.syncHeights && el.syncHeights();
        return;
      }
      if (el.parentNode) {
        const clone = document.createElement('card-product-slider');
        for (let i = 0; i < el.attributes.length; i++) {
          const a = el.attributes[i];
          clone.setAttribute(a.name, a.value);
        }
        clone.innerHTML = el.innerHTML;
        el.parentNode.replaceChild(clone, el);
      }
    } catch (err) {
      console.error(err);
    }
  });
}

let ispaused = false
async function loadDraweRecomendations(needsPause){
  if((needsPause && !ispaused) || !ispaused){
    ispaused = true
    let cart = await getCurrentCart()
    if(cart.items.length > 0){
    let ProductId = cart.items[0].product_id
    console.log('Carga productos con '+cart.items[0].title)
    await fetch('https://hypsters.com.mx/recommendations/products?section_id=template--18654378492069__recommendations&product_id='+ProductId+'&limit=10')
        .then((response) => response.text())
        .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(
                '.container'
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              const splideTrack = document.createElement('div');
              splideTrack.className = 'splide__track';
              
              const splideList = document.createElement('ul');
              splideList.className = 'splide__list';
              const parser = new DOMParser();
              const doc = parser.parseFromString(recommendations.innerHTML, 'text/html');
              const title = doc.querySelector('.section__heading').textContent
              const liElements = doc.querySelectorAll('.card-product-slider__slide');
              liElements.forEach(li => {
                const slide = document.createElement('li');
                slide.className = `${li.className} splide__slide`;
                slide.innerHTML = li.innerHTML; // Copiar el contenido del <li>
                if (slide.querySelector('product-card')) {
                  splideList.appendChild(slide);
                }
              });
              splideTrack.appendChild(splideList);
              $('.dpl').html(splideTrack)
              $('.dpl').prepend('<h6 style="padding-left:15px">'+title+'</h6>')
              new Splide('.dpl', {
                type: 'loop',
                perPage: 4,
                perMove: 1,
                focus  : 0,
                omitEnd: true,
                breakpoints: {
                  600: {
                    perPage: 3, // 2 slides visibles en pantallas <= 768px
                  },
                  400: {
                    perPage: 2, // 1 slide visible en pantallas <= 480px
                  },
                },
              }).mount()
            }
        })
        .catch((e) => {
          console.log('Hay un errooooooor')
            console.error(e);
        });
  }
    setTimeout(() => {
      ispaused = false
    }, 300);
  }
}


async function getCurrentCart() {
  let cart
  await fetch('/cart.js')
  .then(response => {
    if (!response.ok) {
      return response.json().then(error => { throw new Error(error.message); });
    }
    return response.json();
  })
  .then(data => {
      cart = data
  })
  .catch((error) => {
    console.error('Error:-', error);
  });
console.log('Found Cart')
console.log(cart)
  return cart
}